unit PlayerMain;

{ PlayStream - spelaren (webbversionen av Play)
  Steg 1: stil/tempo/hysteres, ny lista, låtlista, Play/Paus, förra/nästa,
  hopp +/-8 sek, tid spelad/kvar, klocka, volym och Plays kortkommandon. }

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WEBLib.ExtCtrls,
  XData.Web.Connection, XData.Web.Client, PlayListBuilder;

const
  // XData-serverns port och sökväg. Värdnamnet tas från sidans adress
  // (localhost/127.0.0.1 under utveckling, serverns namn i drift).
  SERVER_PORT = 2310;
  SERVER_PATH = '/playstream';

  TEMPO_MIN = 40;
  TEMPO_MAX = 300;
  JUMP_SECS = 8;

type
  TPlayerForm = class(TForm)
    XDataWebConnection1: TXDataWebConnection;
    XDataWebClient1: TXDataWebClient;
    ClockTimer: TTimer;
    procedure WebFormCreate(Sender: TObject);
    procedure XDataWebConnection1Connect(Sender: TObject);
    procedure ClockTimerTimer(Sender: TObject);
  private
    FAudio: TJSHTMLElement;
    FSongs: TJSArray;     // aktuell låtlista (JSON-objekt från servern)
    FStiles: TJSArray;    // dansstilar
    FPlaying: Integer;    // index i FSongs som spelas (-1 = ingen)
    FSelected: Integer;   // markerad rad i listan
    FDance: Integer;
    FTempo: Integer;
    FHysteres: Integer;
    FConnected: Boolean;
    FServerUrl: string;
    FCode: string;        // fjärrkod (4 siffror)
    FSyncBusy: Boolean;
    FSyncTick: Integer;   // räknare: full status skickas var 4:e gång (1/sek)
    FStateDirty: Boolean; // skicka status direkt (efter ett kommando)
    FAck: string;         // senaste hälsning från en fjärrkontroll (bekräftas i status)
    FArmed: Boolean;      // någon har tryckt på sidan -> webbläsaren tillåter ljud
    FPendingToken: string; // fjärrkontroll som väntar på godkännande
    FMode: string;        // '' = startsidan, 'play' = spelläge, 'list' = listläge
    FListBuilder: TListBuilder;
    FSavedId: Integer;     // sparad lista som spelas (0 = automatisk lista från stil/tempo)
    FSavedName: string;
    FSavedLists: TJSArray; // [{id, name, count}] - listorna som kan väljas

    // Hjälpare för sidan
    function El(const AId: string): TJSHTMLElement;
    procedure SetText(const AId, AText: string);
    procedure Bind(const AId, AEvent: string; AHandler: TJSEventHandler);
    function Esc(const S: string): string;
    function MinSec(Secs: Double): string;
    function SongCount: Integer;
    function SongAt(Index: Integer): TJSObject;
    function StileName(AId: Integer): string;

    // Ljudspelaren (HTML5 <audio>)
    procedure AudioLoad(const AUrl: string);
    procedure AudioPlay;
    procedure AudioPause;
    function AudioPaused: Boolean;
    function AudioTime: Double;
    function AudioDuration: Double;
    procedure AudioJump(ASecs: Double);
    procedure AudioSeekFraction(AFrac: Double);
    procedure AudioSetVolume(AVol: Double);

    // Logik (motsvarar Play)
    procedure LoadSettings;
    procedure SaveSettings;
    procedure UpdateSelectionUI;
    procedure FillStileSelect;
    procedure RenderList;
    procedure HighlightList;
    procedure UpdateNowPlaying;
    procedure UpdateProgress;
    procedure ChangeTempo(ADelta: Integer);
    procedure ChangeHysteres(ADelta: Integer);
    procedure CycleStile;
    procedure NewList(AndPlay: Boolean);
    procedure LoadSavedLists;
    procedure FillSavedSelect;
    procedure LoadSaved(AId: Integer; AndPlay: Boolean);
    procedure PlayIndex(AIndex: Integer);
    procedure PlayPause;
    procedure NextSong;
    procedure PrevSong;
    procedure SelectRow(AIndex: Integer);
    procedure ShowError(const AMsg: string);

    // Fjärrkontroll
    function MakeServerUrl: string;
    procedure RegisterRemote;
    procedure SyncRemote;
    function BuildState: string;
    procedure ExecCommand(const ACmd: string);
    procedure SetVolumePercent(APct: Integer);
    procedure SyncTick;
    procedure RemoteHello(const AToken: string);

    // Händelser från sidan
    function BtnNewListClick(Event: TJSEvent): Boolean;
    function BtnTempoM8Click(Event: TJSEvent): Boolean;
    function BtnTempoM3Click(Event: TJSEvent): Boolean;
    function BtnTempoP3Click(Event: TJSEvent): Boolean;
    function BtnTempoP8Click(Event: TJSEvent): Boolean;
    function BtnHystMClick(Event: TJSEvent): Boolean;
    function BtnHystPClick(Event: TJSEvent): Boolean;
    function BtnPlayClick(Event: TJSEvent): Boolean;
    function BtnPrevClick(Event: TJSEvent): Boolean;
    function BtnNextClick(Event: TJSEvent): Boolean;
    function BtnBackClick(Event: TJSEvent): Boolean;
    function BtnFwdClick(Event: TJSEvent): Boolean;
    function StileChange(Event: TJSEvent): Boolean;
    function SavedChange(Event: TJSEvent): Boolean;
    function VolumeInput(Event: TJSEvent): Boolean;
    function ListClick(Event: TJSEvent): Boolean;
    function ListDblClick(Event: TJSEvent): Boolean;
    function ProgClick(Event: TJSEvent): Boolean;
    function AudioTimeUpdate(Event: TJSEvent): Boolean;
    function AudioEnded(Event: TJSEvent): Boolean;
    function AudioStateChange(Event: TJSEvent): Boolean;
    function KeyDown(Event: TJSEvent): Boolean;
    function SwapRemoteClick(Event: TJSEvent): Boolean;
    function StartOverlayClick(Event: TJSEvent): Boolean;
    function ApproveClick(Event: TJSEvent): Boolean;
    function ChoosePlayClick(Event: TJSEvent): Boolean;
    function ChooseListClick(Event: TJSEvent): Boolean;
    function ListBackClick(Event: TJSEvent): Boolean;
    function DenyClick(Event: TJSEvent): Boolean;
    procedure RemoteRequest(const AToken: string);
    procedure AnswerRemote(Accept: Boolean);
    procedure ShowStartOverlay;
  protected procedure LoadDFMValues; override; end;

var
  PlayerForm: TPlayerForm;

implementation

{$R *.dfm}

{ ---------- Hjälpare ---------- }

function TPlayerForm.El(const AId: string): TJSHTMLElement;
begin
  Result := TJSHTMLElement(document.getElementById(AId));
end;

procedure TPlayerForm.SetText(const AId, AText: string);
var
  E: TJSHTMLElement;
begin
  E := El(AId);
  if Assigned(E) then
    E.innerText := AText;
end;

procedure TPlayerForm.Bind(const AId, AEvent: string; AHandler: TJSEventHandler);
var
  E: TJSHTMLElement;
begin
  E := El(AId);
  if Assigned(E) then
    E.addEventListener(AEvent, AHandler);
end;

function TPlayerForm.Esc(const S: string): string;
begin
  Result := StringReplace(S, '&', '&amp;', [rfReplaceAll]);
  Result := StringReplace(Result, '<', '&lt;', [rfReplaceAll]);
  Result := StringReplace(Result, '>', '&gt;', [rfReplaceAll]);
  Result := StringReplace(Result, '"', '&quot;', [rfReplaceAll]);
end;

function TPlayerForm.MinSec(Secs: Double): string;
var
  T, M, S: Integer;
begin
  if Secs < 0 then
    Secs := 0;
  T := Trunc(Secs);
  M := T div 60;
  S := T mod 60;
  if S < 10 then
    Result := IntToStr(M) + ':0' + IntToStr(S)
  else
    Result := IntToStr(M) + ':' + IntToStr(S);
end;

function TPlayerForm.SongCount: Integer;
begin
  if Assigned(FSongs) then
    Result := FSongs.length
  else
    Result := 0;
end;

function TPlayerForm.SongAt(Index: Integer): TJSObject;
begin
  Result := TJSObject(FSongs[Index]);
end;

function TPlayerForm.StileName(AId: Integer): string;
var
  i: Integer;
  O: TJSObject;
begin
  Result := '';
  if not Assigned(FStiles) then
    Exit;
  for i := 0 to FStiles.length - 1 do
  begin
    O := TJSObject(FStiles[i]);
    if toInteger(O['id']) = AId then
      Exit(string(O['name']));
  end;
end;

{ ---------- Ljudspelaren ---------- }

procedure TPlayerForm.AudioLoad(const AUrl: string);
begin
  asm
    this.FAudio.src = AUrl;
  end;
end;

procedure TPlayerForm.AudioPlay;
begin
  asm
    var self = this;
    var p = this.FAudio.play();
    if (p && p.catch) p.catch(function(e){
      console.log('play:', e);
      // Webbläsaren stoppade ljudet: be om ett tryck på sidan
      if (e && e.name === 'NotAllowedError') {
        self.FArmed = false;
        self.FStateDirty = true;
        var ov = document.getElementById('startOverlay');
        if (ov) ov.classList.remove('ps-hidden');
      }
    });
  end;
end;

procedure TPlayerForm.AudioPause;
begin
  asm
    this.FAudio.pause();
  end;
end;

function TPlayerForm.AudioPaused: Boolean;
begin
  Result := True;
  asm
    Result = this.FAudio.paused;
  end;
end;

function TPlayerForm.AudioTime: Double;
begin
  Result := 0;
  asm
    Result = this.FAudio.currentTime || 0;
  end;
end;

function TPlayerForm.AudioDuration: Double;
begin
  Result := 0;
  asm
    var d = this.FAudio.duration;
    Result = (isFinite(d) && d > 0) ? d : 0;
  end;
end;

procedure TPlayerForm.AudioJump(ASecs: Double);
begin
  asm
    var a = this.FAudio;
    var t = (a.currentTime || 0) + ASecs;
    if (t < 0) t = 0;
    if (isFinite(a.duration) && t > a.duration - 1) t = a.duration - 1;
    a.currentTime = t;
  end;
end;

procedure TPlayerForm.AudioSeekFraction(AFrac: Double);
begin
  asm
    var a = this.FAudio;
    if (isFinite(a.duration) && a.duration > 0) a.currentTime = a.duration * AFrac;
  end;
end;

procedure TPlayerForm.AudioSetVolume(AVol: Double);
begin
  asm
    this.FAudio.volume = AVol;
  end;
end;

{ ---------- Inställningar (sparas i webbläsaren, som INI-filen i Play) ---------- }

procedure TPlayerForm.LoadSettings;
var
  D, T, H, C: string;
begin
  D := ''; T := ''; H := '';
  C := '';
  asm
    try {
      D = localStorage.getItem('ps_dance') || '';
      T = localStorage.getItem('ps_tempo') || '';
      H = localStorage.getItem('ps_hysteres') || '';
    } catch (e) {}
  end;
  FDance := StrToIntDef(D, 1);
  FTempo := StrToIntDef(T, 140);
  FHysteres := StrToIntDef(H, 3);
  // Fjärrkoden sparas inte: spelaren får en ny kod vid varje start
end;

procedure TPlayerForm.SaveSettings;
var
  D, T, H: string;
begin
  D := IntToStr(FDance);
  T := IntToStr(FTempo);
  H := IntToStr(FHysteres);
  asm
    try {
      localStorage.setItem('ps_dance', D);
      localStorage.setItem('ps_tempo', T);
      localStorage.setItem('ps_hysteres', H);
    } catch (e) {}
  end;
end;

{ ---------- Visning ---------- }

procedure TPlayerForm.UpdateSelectionUI;
var
  N: string;
  Sel: TJSHTMLElement;
begin
  SetText('tempoValue', IntToStr(FTempo));
  SetText('hystValue', IntToStr(FHysteres));
  SetText('clockTempo', IntToStr(FTempo));
  N := StileName(FDance);
  if N = '' then
    N := '?';
  SetText('btnNewList', 'Skapa/Starta ny ' + N + ' lista');
  Sel := El('selStile');
  if Assigned(Sel) then
    TJSHTMLSelectElement(Sel).value := IntToStr(FDance);
end;

procedure TPlayerForm.FillStileSelect;
var
  i: Integer;
  O: TJSObject;
  H: string;
begin
  H := '';
  for i := 0 to FStiles.length - 1 do
  begin
    O := TJSObject(FStiles[i]);
    H := H + '<option value="' + IntToStr(toInteger(O['id'])) + '">' +
      Esc(string(O['name'])) + '</option>';
  end;
  El('selStile').innerHTML := H;
  UpdateSelectionUI;
end;

procedure TPlayerForm.RenderList;
var
  i: Integer;
  O: TJSObject;
  H: string;
begin
  H := '';
  for i := 0 to SongCount - 1 do
  begin
    O := SongAt(i);
    H := H + '<li data-i="' + IntToStr(i) + '">' +
      '<span class="t">' + IntToStr(toInteger(O['tempo'])) + '</span>' +
      '<span class="n">' + Esc(string(O['title'])) +
        ' <span class="a">– ' + Esc(string(O['artist'])) + '</span></span>' +
      '<span class="nr">' + IntToStr(i + 1) + '</span>' +
      '</li>';
  end;
  El('songList').innerHTML := H;
  if FSavedId > 0 then
    SetText('listInfo', 'Sparad lista: ' + FSavedName + ' – ' + IntToStr(SongCount) + ' låtar')
  else
    SetText('listInfo', IntToStr(SongCount) + ' låtar – ' + StileName(FDance) +
      ' ' + IntToStr(FTempo - FHysteres) + '–' + IntToStr(FTempo + FHysteres));
  HighlightList;
end;

procedure TPlayerForm.HighlightList;
var
  Sel, Play: Integer;
begin
  Sel := FSelected;
  Play := FPlaying;
  asm
    var items = document.querySelectorAll('#songList li');
    for (var i = 0; i < items.length; i++) {
      items[i].classList.toggle('sel', i === Sel && i !== Play);
      items[i].classList.toggle('playing', i === Play);
    }
    var cur = items[Sel];
    if (cur) cur.scrollIntoView({ block: 'nearest' });
  end;
end;

procedure TPlayerForm.UpdateNowPlaying;
var
  O: TJSObject;
begin
  if (FPlaying >= 0) and (FPlaying < SongCount) then
  begin
    O := SongAt(FPlaying);
    SetText('nowPlaying', string(O['title']) + ' – ' + string(O['artist']) +
      '  (' + IntToStr(toInteger(O['tempo'])) + ')');
  end
  else
    SetText('nowPlaying', 'Ingen låt spelas');
end;

procedure TPlayerForm.UpdateProgress;
var
  Cur, Dur, Left: Double;
  Pct: Double;
  Bar: TJSHTMLElement;
begin
  Cur := AudioTime;
  Dur := AudioDuration;
  Left := Dur - Cur;
  SetText('timePlayed', MinSec(Cur));
  SetText('timeLeft', MinSec(Left));

  Bar := El('progBar');
  if Dur > 0 then
    Pct := Cur / Dur * 100
  else
    Pct := 0;
  // Punkt som decimaltecken (CSS förstår inte svenskt komma)
  asm
    Bar.style.width = Pct.toFixed(2) + '%';
  end;

  // Som i Play: röd mot slutet
  Bar.classList.remove('warn');
  Bar.classList.remove('end');
  if (Dur > 0) and (Left < 30) then
    Bar.classList.add('end')
  else if (Dur > 0) and (Left < 60) then
    Bar.classList.add('warn');
end;

procedure TPlayerForm.ShowError(const AMsg: string);
begin
  SetText('status', AMsg);
  console.log(AMsg);
end;

{ ---------- Logik ---------- }

procedure TPlayerForm.ChangeTempo(ADelta: Integer);
begin
  FTempo := FTempo + ADelta;
  if FTempo < TEMPO_MIN then
    FTempo := TEMPO_MIN;
  if FTempo > TEMPO_MAX then
    FTempo := TEMPO_MAX;
  UpdateSelectionUI;
  SaveSettings;
end;

procedure TPlayerForm.ChangeHysteres(ADelta: Integer);
begin
  FHysteres := FHysteres + ADelta;
  if FHysteres < 0 then
    FHysteres := 0;
  if FHysteres > 30 then
    FHysteres := 30;
  UpdateSelectionUI;
  SaveSettings;
end;

procedure TPlayerForm.CycleStile;
begin
  // Samma ordning som tangenten B i Play: Bugg, Boogie, Rock, Lindy, Fox
  case FDance of
    1: FDance := 2;
    2: FDance := 3;
    3: FDance := 4;
    4: FDance := 10;
  else
    FDance := 1;
  end;
  UpdateSelectionUI;
  SaveSettings;
end;

procedure TPlayerForm.NewList(AndPlay: Boolean);
begin
  if not FConnected then
    Exit;
  // Ny automatisk lista = vi lämnar den sparade listan
  FSavedId := 0;
  FSavedName := '';
  if Assigned(El('selSaved')) then
    TJSHTMLSelectElement(El('selSaved')).value := '0';
  SetText('status', 'Hämtar lista...');
  XDataWebClient1.RawInvoke('IPlayService.NewSongList', [FDance, FTempo, FHysteres],
    procedure(Response: TXDataClientResponse)
    var
      Obj: TJSObject;
    begin
      Obj := TJSObject(TJSJSON.parse(Response.ResponseText));
      FSongs := TJSArray(TJSJSON.parse(string(Obj['value'])));
      FSelected := 0;
      FPlaying := -1;
      RenderList;
      SetText('status', '');
      if SongCount = 0 then
        SetText('status', 'Inga låtar hittades för ' + StileName(FDance) + ' i tempo ' +
          IntToStr(FTempo - FHysteres) + '–' + IntToStr(FTempo + FHysteres))
      else if AndPlay then
        PlayIndex(0);
    end,
    procedure(Error: TXDataClientError)
    begin
      ShowError('Kunde inte hämta lista: ' + Error.ErrorMessage);
    end);
end;

{ ---------- Sparade listor (byggda i "Bygg spellista") ---------- }

procedure TPlayerForm.LoadSavedLists;
begin
  if not FConnected then
    Exit;
  XDataWebClient1.RawInvoke('IPlayService.GetPlaylists', [],
    procedure(Response: TXDataClientResponse)
    var
      Obj: TJSObject;
    begin
      Obj := TJSObject(TJSJSON.parse(Response.ResponseText));
      FSavedLists := TJSArray(TJSJSON.parse(string(Obj['value'])));
      FillSavedSelect;
      FStateDirty := True;
    end,
    procedure(Error: TXDataClientError)
    begin
      ShowError('Kunde inte hämta sparade listor: ' + Error.ErrorMessage);
    end);
end;

procedure TPlayerForm.FillSavedSelect;
var
  i: Integer;
  O: TJSObject;
  H: string;
begin
  H := '<option value="0">– Ingen: stil och tempo –</option>';
  if Assigned(FSavedLists) then
    for i := 0 to FSavedLists.length - 1 do
    begin
      O := TJSObject(FSavedLists[i]);
      H := H + '<option value="' + IntToStr(toInteger(O['id'])) + '">' +
        Esc(string(O['name'])) + ' (' + IntToStr(toInteger(O['count'])) + ')</option>';
    end;
  El('selSaved').innerHTML := H;
  TJSHTMLSelectElement(El('selSaved')).value := IntToStr(FSavedId);
end;

procedure TPlayerForm.LoadSaved(AId: Integer; AndPlay: Boolean);
begin
  if not FConnected then
    Exit;
  if AId <= 0 then
  begin
    NewList(AndPlay);   // tillbaka till automatisk lista
    Exit;
  end;
  SetText('status', 'Hämtar sparad lista...');
  XDataWebClient1.RawInvoke('IPlayService.GetPlaylist', [AId],
    procedure(Response: TXDataClientResponse)
    var
      Obj, Root: TJSObject;
    begin
      Obj := TJSObject(TJSJSON.parse(Response.ResponseText));
      Root := TJSObject(TJSJSON.parse(string(Obj['value'])));
      if not isArray(Root['songs']) then
      begin
        SetText('status', 'Listan finns inte längre.');
        LoadSavedLists;
        Exit;
      end;
      FSavedId := AId;
      FSavedName := string(Root['name']);
      FSongs := TJSArray(Root['songs']);
      FSelected := 0;
      FPlaying := -1;
      TJSHTMLSelectElement(El('selSaved')).value := IntToStr(AId);
      RenderList;
      FStateDirty := True;
      if SongCount = 0 then
        SetText('status', 'Listan "' + FSavedName + '" är tom.')
      else
      begin
        SetText('status', '');
        if AndPlay then
          PlayIndex(0);
      end;
    end,
    procedure(Error: TXDataClientError)
    begin
      ShowError('Kunde inte hämta listan: ' + Error.ErrorMessage);
    end);
end;

procedure TPlayerForm.PlayIndex(AIndex: Integer);
begin
  if (AIndex < 0) or (AIndex >= SongCount) then
    Exit;
  FPlaying := AIndex;
  FSelected := AIndex;
  AudioLoad(FServerUrl + '/media/' + IntToStr(toInteger(SongAt(AIndex)['id'])));
  AudioPlay;
  UpdateNowPlaying;
  HighlightList;
end;

procedure TPlayerForm.PlayPause;
begin
  if SongCount = 0 then
    Exit;
  // Annan låt markerad än den som spelas -> spela den markerade
  if (FPlaying < 0) or (FSelected <> FPlaying) then
  begin
    PlayIndex(FSelected);
    Exit;
  end;
  if AudioPaused then
  begin
    // Som i Play: under 45 sek kvar -> gå till nästa låt i stället
    if (AudioDuration > 0) and (AudioDuration - AudioTime < 45) then
      NextSong
    else
      AudioPlay;
  end
  else
    AudioPause;
end;

procedure TPlayerForm.NextSong;
var
  Cur: Integer;
begin
  Cur := FPlaying;
  if Cur < 0 then
    Cur := FSelected - 1;
  if Cur < SongCount - 1 then
    PlayIndex(Cur + 1)
  else if FSavedId > 0 then
    // Sparad lista: stanna när den är slut (ingen automatisk ny lista)
    SetText('status', 'Listan "' + FSavedName + '" är slut. Välj en ny lista eller tryck "Skapa/Starta ny lista".')
  else
    NewList(True); // slut på listan -> ny lista, som i Play
end;

procedure TPlayerForm.PrevSong;
begin
  if FPlaying > 0 then
    PlayIndex(FPlaying - 1);
end;

procedure TPlayerForm.SelectRow(AIndex: Integer);
begin
  if (AIndex < 0) or (AIndex >= SongCount) then
    Exit;
  FSelected := AIndex;
  HighlightList;
end;

{ ---------- Händelser ---------- }

function TPlayerForm.BtnNewListClick(Event: TJSEvent): Boolean;
begin
  NewList(True);
  Result := True;
end;

function TPlayerForm.BtnTempoM8Click(Event: TJSEvent): Boolean;
begin
  ChangeTempo(-8);
  Result := True;
end;

function TPlayerForm.BtnTempoM3Click(Event: TJSEvent): Boolean;
begin
  ChangeTempo(-3);
  Result := True;
end;

function TPlayerForm.BtnTempoP3Click(Event: TJSEvent): Boolean;
begin
  ChangeTempo(3);
  Result := True;
end;

function TPlayerForm.BtnTempoP8Click(Event: TJSEvent): Boolean;
begin
  ChangeTempo(8);
  Result := True;
end;

function TPlayerForm.BtnHystMClick(Event: TJSEvent): Boolean;
begin
  ChangeHysteres(-1);
  Result := True;
end;

function TPlayerForm.BtnHystPClick(Event: TJSEvent): Boolean;
begin
  ChangeHysteres(1);
  Result := True;
end;

function TPlayerForm.BtnPlayClick(Event: TJSEvent): Boolean;
begin
  PlayPause;
  Result := True;
end;

function TPlayerForm.BtnPrevClick(Event: TJSEvent): Boolean;
begin
  PrevSong;
  Result := True;
end;

function TPlayerForm.BtnNextClick(Event: TJSEvent): Boolean;
begin
  NextSong;
  Result := True;
end;

function TPlayerForm.BtnBackClick(Event: TJSEvent): Boolean;
begin
  AudioJump(-JUMP_SECS);
  Result := True;
end;

function TPlayerForm.BtnFwdClick(Event: TJSEvent): Boolean;
begin
  AudioJump(JUMP_SECS);
  Result := True;
end;

function TPlayerForm.StileChange(Event: TJSEvent): Boolean;
begin
  FDance := StrToIntDef(TJSHTMLSelectElement(El('selStile')).value, 1);
  UpdateSelectionUI;
  SaveSettings;
  Result := True;
end;

function TPlayerForm.SavedChange(Event: TJSEvent): Boolean;
begin
  LoadSaved(StrToIntDef(TJSHTMLSelectElement(El('selSaved')).value, 0), False);
  TJSHTMLElement(El('selSaved')).blur;
  Result := True;
end;

function TPlayerForm.VolumeInput(Event: TJSEvent): Boolean;
var
  V: string;
begin
  V := TJSHTMLInputElement(El('volume')).value;
  SetVolumePercent(StrToIntDef(V, 100));
  Result := True;
end;

function TPlayerForm.ListClick(Event: TJSEvent): Boolean;
var
  Idx: Integer;
begin
  Idx := -1;
  asm
    var li = Event.target.closest('li');
    if (li) Idx = parseInt(li.dataset.i);
  end;
  SelectRow(Idx);
  Result := True;
end;

function TPlayerForm.ListDblClick(Event: TJSEvent): Boolean;
var
  Idx: Integer;
begin
  Idx := -1;
  asm
    var li = Event.target.closest('li');
    if (li) Idx = parseInt(li.dataset.i);
  end;
  PlayIndex(Idx);
  Result := True;
end;

function TPlayerForm.ProgClick(Event: TJSEvent): Boolean;
var
  Frac: Double;
begin
  Frac := 0;
  asm
    var r = Event.currentTarget.getBoundingClientRect();
    Frac = (Event.clientX - r.left) / r.width;
  end;
  AudioSeekFraction(Frac);
  Result := True;
end;

function TPlayerForm.AudioTimeUpdate(Event: TJSEvent): Boolean;
begin
  UpdateProgress;
  Result := True;
end;

function TPlayerForm.AudioEnded(Event: TJSEvent): Boolean;
begin
  NextSong;
  Result := True;
end;

function TPlayerForm.AudioStateChange(Event: TJSEvent): Boolean;
var
  B: TJSHTMLElement;
begin
  B := El('btnPlay');
  if AudioPaused then
  begin
    B.innerText := 'PLAY';
    B.classList.remove('playing');
  end
  else
  begin
    B.innerText := 'PAUS';
    B.classList.add('playing');
  end;
  Result := True;
end;

function TPlayerForm.KeyDown(Event: TJSEvent): Boolean;
var
  K: Integer;
  InSelect: Boolean;
begin
  Result := True;
  if FMode <> 'play' then
    Exit; // kortkommandona gäller bara i spelläget
  K := 0;
  InSelect := False;
  asm
    K = Event.keyCode;
    var tg = Event.target && Event.target.tagName;
    InSelect = (tg === 'SELECT' || tg === 'INPUT');
  end;
  if InSelect and (K <> 13) then
    Exit;

  // Samma tangenter som i Play
  case K of
    38: SelectRow(FSelected - 1);                 // pil upp
    40: SelectRow(FSelected + 1);                 // pil ner
    66: CycleStile;                               // B
    73: ChangeTempo(-8);                          // I
    79: ChangeTempo(8);                           // O
    75, 37: ChangeTempo(-3);                      // K, pil vänster
    76, 39: ChangeTempo(3);                       // L, pil höger
    78, 176, 119, 190: NextSong;                  // N, media-nästa, F8, punkt
    70, 177, 118, 188: PrevSong;                  // F, media-förra, F7, komma
    13: NewList(True);                            // Enter
    32, 179: PlayPause;                           // mellanslag, media play/paus
  else
    Exit;
  end;
  Event.preventDefault;
end;

{ ---------- Fjärrkontroll ---------- }

function TPlayerForm.MakeServerUrl: string;
var
  Proto, Host: string;
begin
  Proto := 'http:';
  Host := 'localhost';
  asm
    Proto = window.location.protocol;
    Host = window.location.hostname;
  end;
  // Utveckling (localhost): direkt mot XData-servern på port 2310.
  // På riktigt (t.ex. https://playstream.mic.tf): samma adress som sidan, via IIS.
  if (Host = '') or (Host = '127.0.0.1') or (Host = 'localhost') or (Proto = 'file:') then
    Result := 'http://localhost:' + IntToStr(SERVER_PORT) + SERVER_PATH
  else
    Result := Proto + '//' + Host + SERVER_PATH;
end;

procedure TPlayerForm.RegisterRemote;
var
  OldCode: string;
begin
  // Ny kod vid start och vid "Byt fjärr". Den gamla koden slutar gälla på servern.
  OldCode := FCode;
  FCode := '';
  FAck := '';
  FPendingToken := '';
  El('approveOverlay').classList.add('ps-hidden');
  SetText('remoteCode', '----');
  SetText('startCode', '----');
  SetText('remoteState', 'Väntar på fjärr');
  El('remoteBadge').classList.remove('linked');
  XDataWebClient1.RawInvoke('IPlayService.RegisterPlayer', [OldCode],
    procedure(Response: TXDataClientResponse)
    var
      Obj: TJSObject;
    begin
      Obj := TJSObject(TJSJSON.parse(Response.ResponseText));
      FCode := string(Obj['value']);
      SetText('remoteCode', FCode);
      SetText('startCode', FCode);
      FStateDirty := True;
    end,
    procedure(Error: TXDataClientError)
    begin
      ShowError('Kunde inte registrera fjärrkod: ' + Error.ErrorMessage);
    end);
end;

function TPlayerForm.BuildState: string;
var
  O, S: TJSObject;
  Nxt, Lists: TJSArray;
  i, Start, Vol: Integer;
  Song: TJSObject;
begin
  O := TJSObject.new;
  O['dance'] := FDance;
  O['danceName'] := StileName(FDance);
  O['tempo'] := FTempo;
  O['hysteres'] := FHysteres;
  O['paused'] := AudioPaused;
  O['played'] := Trunc(AudioTime);
  O['duration'] := Trunc(AudioDuration);
  O['count'] := SongCount;
  O['index'] := FPlaying;
  O['selected'] := FSelected;
  Vol := 100;
  asm
    Vol = Math.round(this.FAudio.volume * 100);
  end;
  O['volume'] := Vol;
  O['ack'] := FAck;
  O['armed'] := FArmed;
  O['listId'] := FSavedId;
  O['listName'] := FSavedName;
  // Listorna som fjärrkontrollen kan välja bland (bara id och namn)
  Lists := TJSArray.new;
  if Assigned(FSavedLists) then
    for i := 0 to FSavedLists.length - 1 do
    begin
      S := TJSObject.new;
      S['id'] := TJSObject(FSavedLists[i])['id'];
      S['name'] := TJSObject(FSavedLists[i])['name'];
      Lists.push(S);
    end;
  O['lists'] := Lists;

  if (FPlaying >= 0) and (FPlaying < SongCount) then
  begin
    Song := SongAt(FPlaying);
    O['title'] := Song['title'];
    O['artist'] := Song['artist'];
    O['songTempo'] := Song['tempo'];
  end
  else
  begin
    O['title'] := '';
    O['artist'] := '';
    O['songTempo'] := 0;
  end;

  // De närmaste låtarna i listan
  Nxt := TJSArray.new;
  Start := FPlaying;
  if Start < 0 then
    Start := FSelected - 1;
  for i := Start + 1 to Start + 8 do
  begin
    if (i < 0) or (i >= SongCount) then
      Continue;
    Song := SongAt(i);
    S := TJSObject.new;
    S['i'] := i;
    S['title'] := Song['title'];
    S['artist'] := Song['artist'];
    S['tempo'] := Song['tempo'];
    Nxt.push(S);
  end;
  O['next'] := Nxt;

  Result := TJSJSON.stringify(O);
end;

procedure TPlayerForm.SyncRemote;
var
  State: string;
begin
  // Full status 1 gång/sek eller direkt efter ett kommando, annars bara "några kommandon?"
  Inc(FSyncTick);
  if FStateDirty or (FSyncTick mod 4 = 0) then
  begin
    FStateDirty := False;
    try
      State := BuildState;
    except
      on E: Exception do
      begin
        ShowError('Fjärr: kunde inte bygga status: ' + E.Message);
        Exit;
      end;
    end;
  end
  else
    State := '';


  FSyncBusy := True;
  XDataWebClient1.RawInvoke('IPlayService.PlayerSync', [FCode, State],
    procedure(Response: TXDataClientResponse)
    var
      Obj: TJSObject;
      Cmds: TJSArray;
      i: Integer;
    begin
      FSyncBusy := False;
      try
        Obj := TJSObject(TJSJSON.parse(Response.ResponseText));
        if string(Obj['value']) = '"REGISTER"' then
        begin
          // Servern känner inte igen koden (t.ex. omstartad): hämta en ny
          FCode := '';
          RegisterRemote;
          Exit;
        end;
        Cmds := TJSArray(TJSJSON.parse(string(Obj['value'])));
        for i := 0 to Cmds.length - 1 do
          ExecCommand(string(Cmds[i]));
        if Cmds.length > 0 then
          FStateDirty := True;
      except
        on E: Exception do
          ShowError('Fjärr: fel vid kommando: ' + E.Message);
      end;
    end,
    procedure(Error: TXDataClientError)
    begin
      FSyncBusy := False;
      ShowError('Fjärr: synk misslyckades: ' + Error.ErrorMessage);
    end);
end;

procedure TPlayerForm.RemoteRequest(const AToken: string);
begin
  // En ny fjärrkontroll vill styra: fråga den som står vid spelaren
  FPendingToken := AToken;
  El('approveOverlay').classList.remove('ps-hidden');
end;

procedure TPlayerForm.AnswerRemote(Accept: Boolean);
var
  Token: string;
begin
  Token := FPendingToken;
  FPendingToken := '';
  El('approveOverlay').classList.add('ps-hidden');
  if Token = '' then
    Exit;
  XDataWebClient1.RawInvoke('IPlayService.ApproveRemote', [FCode, Token, Accept],
    procedure(Response: TXDataClientResponse)
    var
      Obj: TJSObject;
    begin
      Obj := TJSObject(TJSJSON.parse(Response.ResponseText));
      if string(Obj['value']) = 'GODKÄND' then
        RemoteHello(Token)   // bekräfta till fjärrkontrollen + visa "ansluten"
      else
        SetText('remoteState', 'Fjärrkontroll nekad');
    end,
    procedure(Error: TXDataClientError)
    begin
      ShowError('Kunde inte svara fjärrkontrollen: ' + Error.ErrorMessage);
    end);
end;

function TPlayerForm.ChoosePlayClick(Event: TJSEvent): Boolean;
begin
  // Spelläget: här räknas speltiden (debitering läggs till i ett senare steg)
  FMode := 'play';
  El('choiceOverlay').classList.add('ps-hidden');
  El('startOverlay').classList.remove('ps-hidden');
  if FConnected and (FCode = '') then
    RegisterRemote;
  LoadSavedLists;    // listorna kan ha ändrats i "Bygg spellista"
  Result := True;
end;

function TPlayerForm.ChooseListClick(Event: TJSEvent): Boolean;
begin
  // Listläget: ingen fjärrkod, ingen speltid
  FMode := 'list';
  El('choiceOverlay').classList.add('ps-hidden');
  El('listMode').classList.remove('ps-hidden');
  FListBuilder.Open(FStiles);
  Result := True;
end;

function TPlayerForm.ListBackClick(Event: TJSEvent): Boolean;
begin
  FMode := '';
  FListBuilder.Close;
  El('listMode').classList.add('ps-hidden');
  El('choiceOverlay').classList.remove('ps-hidden');
  Result := True;
end;

function TPlayerForm.ApproveClick(Event: TJSEvent): Boolean;
begin
  // Trycket räknas även som "Starta" (webbläsaren tillåter ljud)
  FArmed := True;
  FStateDirty := True;
  El('startOverlay').classList.add('ps-hidden');
  AnswerRemote(True);
  Result := True;
end;

function TPlayerForm.DenyClick(Event: TJSEvent): Boolean;
begin
  AnswerRemote(False);
  Result := True;
end;

procedure TPlayerForm.ShowStartOverlay;
begin
  FArmed := False;
  FStateDirty := True;
  El('startOverlay').classList.remove('ps-hidden');
end;

function TPlayerForm.StartOverlayClick(Event: TJSEvent): Boolean;
begin
  // Ett tryck på sidan = webbläsaren tillåter ljud från och med nu
  FArmed := True;
  FStateDirty := True;
  El('startOverlay').classList.add('ps-hidden');
  Result := True;
end;

function TPlayerForm.SwapRemoteClick(Event: TJSEvent): Boolean;
begin
  RegisterRemote;
  Result := True;
end;

procedure TPlayerForm.RemoteHello(const AToken: string);
begin
  FAck := AToken;
  FStateDirty := True;
  El('remoteBadge').classList.add('linked');
  SetText('remoteState', 'Fjärr ansluten');
  // Visa en tydlig ruta i några sekunder
  asm
    var t = document.getElementById('toast');
    if (t) {
      t.classList.add('show');
      clearTimeout(this.FToastTimer);
      this.FToastTimer = setTimeout(function(){ t.classList.remove('show'); }, 4000);
    }
  end;
end;

procedure TPlayerForm.SyncTick;
begin
  if (FMode = 'play') and FConnected and (FCode <> '') and not FSyncBusy then
    SyncRemote;
end;

procedure TPlayerForm.SetVolumePercent(APct: Integer);
begin
  if APct < 0 then
    APct := 0;
  if APct > 100 then
    APct := 100;
  AudioSetVolume(APct / 100);
  TJSHTMLInputElement(El('volume')).value := IntToStr(APct);
end;

procedure TPlayerForm.ExecCommand(const ACmd: string);
var
  Name, Arg: string;
  P: Integer;
begin
  P := Pos(':', ACmd);
  if P > 0 then
  begin
    Name := Copy(ACmd, 1, P - 1);
    Arg := Copy(ACmd, P + 1, MaxInt);
  end
  else
  begin
    Name := ACmd;
    Arg := '';
  end;

  if Name = 'playpause' then PlayPause
  else if Name = 'next' then NextSong
  else if Name = 'prev' then PrevSong
  else if Name = 'back' then AudioJump(-JUMP_SECS)
  else if Name = 'fwd' then AudioJump(JUMP_SECS)
  else if Name = 'newlist' then NewList(True)
  else if Name = 'cycle' then CycleStile
  else if Name = 'tempo' then ChangeTempo(StrToIntDef(Arg, 0))
  else if Name = 'hyst' then ChangeHysteres(StrToIntDef(Arg, 0))
  else if Name = 'vol' then SetVolumePercent(StrToIntDef(Arg, 100))
  else if Name = 'play' then PlayIndex(StrToIntDef(Arg, -1))
  else if Name = 'hello' then RemoteHello(Arg)
  else if Name = 'request' then RemoteRequest(Arg)
  else if Name = 'list' then LoadSaved(StrToIntDef(Arg, 0), False)
  else if Name = 'dance' then
  begin
    FDance := StrToIntDef(Arg, FDance);
    UpdateSelectionUI;
    SaveSettings;
  end;
end;

{ ---------- Start ---------- }

procedure TPlayerForm.WebFormCreate(Sender: TObject);
begin
  FPlaying := -1;
  FSelected := 0;
  FSongs := TJSArray.new;
  FServerUrl := MakeServerUrl;
  FListBuilder := TListBuilder.Create(XDataWebClient1, FServerUrl);
  LoadSettings;

  FAudio := El('audio');

  Bind('btnNewList', 'click', @BtnNewListClick);
  Bind('btnTempoM8', 'click', @BtnTempoM8Click);
  Bind('btnTempoM3', 'click', @BtnTempoM3Click);
  Bind('btnTempoP3', 'click', @BtnTempoP3Click);
  Bind('btnTempoP8', 'click', @BtnTempoP8Click);
  Bind('btnHystM', 'click', @BtnHystMClick);
  Bind('btnHystP', 'click', @BtnHystPClick);
  Bind('btnPlay', 'click', @BtnPlayClick);
  Bind('btnPrev', 'click', @BtnPrevClick);
  Bind('btnNext', 'click', @BtnNextClick);
  Bind('btnBack', 'click', @BtnBackClick);
  Bind('btnFwd', 'click', @BtnFwdClick);
  Bind('selStile', 'change', @StileChange);
  Bind('selSaved', 'change', @SavedChange);
  Bind('volume', 'input', @VolumeInput);
  Bind('songList', 'click', @ListClick);
  Bind('songList', 'dblclick', @ListDblClick);
  Bind('prog', 'click', @ProgClick);
  Bind('btnSwapRemote', 'click', @SwapRemoteClick);
  Bind('startOverlay', 'click', @StartOverlayClick);
  Bind('btnApprove', 'click', @ApproveClick);
  Bind('btnChoosePlay', 'click', @ChoosePlayClick);
  Bind('btnChooseList', 'click', @ChooseListClick);
  Bind('btnListBack', 'click', @ListBackClick);
  Bind('btnDeny', 'click', @DenyClick);
  Bind('audio', 'timeupdate', @AudioTimeUpdate);
  Bind('audio', 'ended', @AudioEnded);
  Bind('audio', 'play', @AudioStateChange);
  Bind('audio', 'pause', @AudioStateChange);
  document.addEventListener('keydown', @KeyDown);

  UpdateSelectionUI;
  ClockTimerTimer(nil);

  // Fjärrkontrollen: fråga efter kommandon 4 gånger i sekunden
  window.setInterval(@SyncTick, 250);

  XDataWebConnection1.URL := FServerUrl;
  XDataWebConnection1.Connected := True;
end;

procedure TPlayerForm.XDataWebConnection1Connect(Sender: TObject);
begin
  FConnected := True;
  SetText('status', 'Ansluten');
  XDataWebClient1.RawInvoke('IPlayService.GetStiles', [],
    procedure(Response: TXDataClientResponse)
    var
      Obj: TJSObject;
    begin
      Obj := TJSObject(TJSJSON.parse(Response.ResponseText));
      FStiles := TJSArray(TJSJSON.parse(string(Obj['value'])));
      FillStileSelect;
      SetText('status', '');
      // Som i Play: skapa en lista direkt, men spela inte
      NewList(False);
      LoadSavedLists;
      // Fjärrkoden skapas först när man väljer "Spela musik"
      if FMode = 'play' then
        RegisterRemote;
    end,
    procedure(Error: TXDataClientError)
    begin
      ShowError('Kunde inte hämta stilar: ' + Error.ErrorMessage);
    end);
end;

procedure TPlayerForm.ClockTimerTimer(Sender: TObject);
begin
  SetText('clockTime', FormatDateTime('hh:nn', Now));
  if not FConnected then
    SetText('status', 'Ansluter till ' + FServerUrl + ' ... (är PlayStreamServer igång?)');
end;

procedure TPlayerForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  XDataWebConnection1 := TXDataWebConnection.Create(Self);
  XDataWebClient1 := TXDataWebClient.Create(Self);
  ClockTimer := TTimer.Create(Self);

  XDataWebConnection1.BeforeLoadDFMValues;
  XDataWebClient1.BeforeLoadDFMValues;
  ClockTimer.BeforeLoadDFMValues;
  try
    Name := 'PlayerForm';
    Width := 640;
    Height := 480;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    XDataWebConnection1.SetParentComponent(Self);
    XDataWebConnection1.Name := 'XDataWebConnection1';
    SetEvent(XDataWebConnection1, Self, 'OnConnect', 'XDataWebConnection1Connect');
    XDataWebConnection1.Left := 40;
    XDataWebConnection1.Top := 30;
    XDataWebClient1.SetParentComponent(Self);
    XDataWebClient1.Name := 'XDataWebClient1';
    XDataWebClient1.Connection := XDataWebConnection1;
    XDataWebClient1.Left := 160;
    XDataWebClient1.Top := 30;
    ClockTimer.SetParentComponent(Self);
    ClockTimer.Name := 'ClockTimer';
    SetEvent(ClockTimer, Self, 'OnTimer', 'ClockTimerTimer');
    ClockTimer.Left := 280;
    ClockTimer.Top := 30;
  finally
    XDataWebConnection1.AfterLoadDFMValues;
    XDataWebClient1.AfterLoadDFMValues;
    ClockTimer.AfterLoadDFMValues;
  end;
end;

end.
